import '../filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.PublishedFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  template: JST["backbone/templates/monitoring/filters/published/published_filter"]

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @socialNetwork = 'facebook'
    @publishedSource = 'published'

  render: ->
    @$el.html(@template(@, publishedSource: @publishedSource))
    @

  getFilterValue: =>
    filterValue = @$el.find('input[type="radio"]:checked').val()
    return @getBooleanOf(filterValue)

  getBooleanOf: (value) ->
    return value unless value?
    value == 'true'
